import React, { useState, createContext } from "react";

const ContextFilter = createContext();

const FilterProvider = ({ children }) => {

  const filterName = 'homeFilter';
  const [filterOn, setFilterOn] = useState(false);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [loadingGrid, setLoadingGrid] = useState(false);
  const [dataGridLoaded, setDataGridLoaded] = useState(false);

  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState([]);
  const [visibleRows, setVisibleRows] = useState([]);
  const [visibleCODRows, setVisibleCODRows] = useState([]);
  const [isDownload, setIsDownload] = useState(false);

  const [searchText, setSearchText] = useState('');
  const [searchTextState, setSearchTextState] = useState('');
  const [filterDatas, setFilterDatas] = useState({ dateSessionStart: null, intraInter: '', status: '' });

  const [dateSessionStart, setDateSessionStart] = useState(null);
  const [intraInter, setIntraInter] = useState('');
  const [status, setStatus] = useState('');

  return (
    <ContextFilter.Provider
      value=
      {{
        filterName,
        filterOn, setFilterOn,
        filterModel, setFilterModel,
        filterDatas, setFilterDatas,
        searchText, setSearchText,
        searchTextState, setSearchTextState,
        dateSessionStart, setDateSessionStart,
        intraInter, setIntraInter,
        status, setStatus,
        
        dataGridLoaded, setDataGridLoaded,
        loadingGrid, setLoadingGrid,
        rows, setRows,
        totalRows, setTotalRows,
        visibleRows, setVisibleRows,
        visibleCODRows, setVisibleCODRows,
        isDownload, setIsDownload
      }}
    >
      {children}
    </ContextFilter.Provider>
  );
};

export { FilterProvider, ContextFilter };
